import { render, staticRenderFns } from "./DynamicEventInterface.vue?vue&type=template&id=ab531b9c&scoped=true&"
import script from "./DynamicEventInterface.vue?vue&type=script&lang=js&"
export * from "./DynamicEventInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab531b9c",
  null
  
)

export default component.exports